module.exports = __webpack_public_path__ + "52af69e708b770449b1c6a53ac498ad9.jpg";